import React, { ReactElement } from 'react'
import { OTHER_INPUT_TYPE } from '../../enums/Options'
import { STEP1_OTHER_UPLOAD_FILES } from '../../enums/common'
import Upload from '../upload/uploadWithRetry/Upload'
import { IOtherUpload } from '../../interfaces/Upload'
import { useTriggerChangeHook } from '../../hooks/triggerChangeHook'

function OtherUpload({
  handleChange,
  register,
  errors,
  files,
  watchOtherDocumentType,
  fileAlerts,
  status,
  state,
  setState,
  validateFile,
  stateIndex,
  isMultifile,
}: IOtherUpload): ReactElement {
  const other_input_type = useTriggerChangeHook('other_input_type')
  const other_input_label = (
    <>
      <span>Autre justificatif *</span>
      <p className="textDanger">
        Les cartes vitales et permis de conduire ne sont pas acceptés.
      </p>
    </>
  )

  return (
    <Upload
      onChange={handleChange}
      options={OTHER_INPUT_TYPE}
      value={other_input_type}
      register={register({ required: true })}
      name="other_input_type"
      id="other_input_type"
      error={errors.other_input_type}
      label={other_input_label}
      uploadFilesTypes={STEP1_OTHER_UPLOAD_FILES}
      files={files}
      fileType={watchOtherDocumentType}
      fileAlerts={fileAlerts}
      status={status}
      state={state}
      setState={setState}
      validateFile={validateFile}
      stateIndex={stateIndex}
      isMultifile={isMultifile}
    />
  )
}

export default OtherUpload
